__webpack_require__.p = "/templates/landscaping/";